export default "__VITE_ASSET__LB9CbwoI__"